/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyUserRole
 */
export interface WriteOnlyUserRole {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyUserRole
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyUserRole
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyUserRole
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyUserRole
     */
    client?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof WriteOnlyUserRole
     */
    userRights: Array<string>;
}

export function WriteOnlyUserRoleFromJSON(json: any): WriteOnlyUserRole {
    return WriteOnlyUserRoleFromJSONTyped(json, false);
}

export function WriteOnlyUserRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyUserRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': json['label'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'client': !exists(json, 'client') ? undefined : json['client'],
        'userRights': json['user_rights'],
    };
}

export function WriteOnlyUserRoleToJSON(value?: WriteOnlyUserRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'description': value.description,
        'client': value.client,
        'user_rights': value.userRights,
    };
}


